import React from 'react';
import PropTypes from 'prop-types';

/**
 * @deprecated Use `Radio.Group` + `Radio` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const RadioCheckList = ({ children, className = '' }) => {
  return <div className={className}>{children}</div>;
};

RadioCheckList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
